import palette from '@lib/core/src/theme/palette';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { styled, Box, InputBase, alpha, Stack, Typography, IconButton } from '@mui/material';

export const Content = styled(Stack)({
  alignItems: 'flex-start',
  width: '100%',
  height: '100%',
  backgroundColor: palette.white,
  borderRadius: '10px',
  padding: '8px'
});

export const ChatWindow = styled(Stack)({
  width: '100%',
  borderRadius: '16px',
  overflow: 'hidden'
});

export const HeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '7px 16px',
  height: '46px',
  backgroundColor: palette.grey[2200],
  color: palette.white,
  width: '100%'
});

export const MeetingTitle = styled(Stack)({
  marginLeft: '10px',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '8px',
  flexGrow: 1,
  width: 'calc(100% - 70px)'
});

export const SuggestionButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.5, 2),
  margin: theme.spacing(0, 2),
  borderRadius: '12px',
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  border: `1px solid ${palette.grey[1200]}`,
  '&:hover': {
    backgroundColor: alpha(palette.black, 0.05)
  }
}));

export const SparkleIcon = styled(AutoAwesomeIcon)(({ theme }) => ({
  marginRight: theme.spacing(1.5),
  fontSize: '1.2rem',
  color: palette.grey[1500]
}));

export const InputArea = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  marginTop: 'auto'
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.grey[500], 0.1),
  borderRadius: '12px',
  padding: theme.spacing(1, 2),
  width: '100%',
  fontSize: '0.95rem'
}));

export const ChatContainer = styled(Stack)({
  position: 'relative',
  width: '100%',
  alignSelf: 'flex-end',
  height: 'calc(100% - 46px)',
  backgroundColor: palette.white,
  alignItems: 'center'
});

export const HumanMessageContainer = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  '.message, .message *': {
    backgroundColor: palette.grey[800],
    borderRadius: '10px',
    padding: '10px',
    maxWidth: '70%',
    whiteSpace: 'pre-wrap',
    fontSize: '13px',
    userSelect: 'text',
    cursor: 'text'
  }
});

export const ChatTitle = styled(Typography)({
  fontSize: '12px',
  color: palette.white,
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100%'
});

export const ChatBubleNumber = styled(Box)({
  position: 'absolute',
  top: 0,
  right: -5,
  width: 20,
  height: 20,
  background: palette.black,
  borderRadius: '50%',
  color: palette.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px'
});

export const SuggestionsContainer = styled(Stack)({
  width: '100%',
  height: '100%',
  '.suggestions-container': {
    padding: '0',
    width: '100%'
  }
});

export const ThreadsIconButton = styled(IconButton)({
  position: 'relative',
  '&:hover': {
    backgroundColor: alpha(palette.white, 0.1)
  }
});

export const RedDot = styled(Stack)({
  position: 'absolute',
  width: 8,
  height: 8,
  backgroundColor: palette.red[100],
  borderRadius: '50%'
});

export const ThreadsButtonRedDot = styled(RedDot)({
  top: '5px',
  right: '5px'
});

export const ThreadsButtonRedDotCount = styled(RedDot)({
  border: `1px solid ${palette.white}`,
  alignItems: 'center',
  justifyContent: 'center',
  top: '-2px',
  right: '-2px',
  width: '16px',
  height: '16px'
});

export const ThreadsButtonRedDotCountText = styled(Typography)({
  fontSize: '11px',
  color: palette.white,
  lineHeight: '16px',
  fontWeight: 600
});

export const ThreadRowRedDot = styled(RedDot)({
  top: '50%',
  left: '0',
  height: '4px',
  width: '4px',
  transform: 'translateY(-50%)'
});
